import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function fetchProcess(token, params) {
    return Api.get(REQUEST_URLS.FIN_CHECK.FETCH_PROCESS, {
        params,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default fetchProcess;